import React, { forwardRef } from 'react';

const AddIcon = ({ width = 20, height = 20, color = '#7357E9' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vuesax/linear/add-circle">
        <g id="add-circle">
          <path
            id="Vector"
            d="M9.99739 18.3356C14.5807 18.3356 18.3307 14.5856 18.3307 10.0023C18.3307 5.41894 14.5807 1.66895 9.99739 1.66895C5.41406 1.66895 1.66406 5.41894 1.66406 10.0023C1.66406 14.5856 5.41406 18.3356 9.99739 18.3356Z"
            stroke={color}
            strokeWidth="1.38"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M6.66406 10.001H13.3307"
            stroke={color}
            strokeWidth="1.38"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M10.0078 13.3356V6.66895"
            stroke={color}
            strokeWidth="1.38"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default forwardRef(AddIcon);
